import type {MobileAuthedWebviewEntryPointConfig} from '../ConnectElementList';

export const payoutPurposeParameter = 'payout-purpose';

export const CreatePayoutConfig: MobileAuthedWebviewEntryPointConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "CreatePayout" */
      '../../../components/Payouts/Balance/BalanceBody/CreatePayoutEntryPoint'
    ),
  description: 'Mobile authed webview entry point to create payout',
  friendlyName: 'Mobile entry point: create payout',
  htmlAttributes: {
    [payoutPurposeParameter]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setPayoutPurpose: {
      type: 'AttributeSettingMethod',
      attribute: payoutPurposeParameter,
      isInternal: true,
      description: 'Set the payout purpose',
    },
  },
};
